import {Injectable} from '@angular/core';

@Injectable()
export class RecentProjectsService {
  projects:any;

  constructor() {
    this.projects = [
      {
        "href": "/sinhvien/thong-tin-ca-nhan/doi-mat-khau",
        "title": "Thay đổi mật khẩu"
      },
      {
        "href": "/sinhvien/support",
        "title": "Trợ giúp"
      },
      // {
      //   "href": "/",
      //   "title": "Assesment Report for merchant account"
      // }
    ]

  }

  getProjects() {
    return this.projects
  }

  clearProjects() {
    this.projects = []
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/recent-projects/recent-projects.service.ts